export interface Task {
    id?: string,
    name: string,
    priority: PRIORITY,
    dueDate: string,
    reminderDate: string,
    tasksRepeat: TaskRepeat | null,
    notify: NOTIFY,
    taskStatus: TASK_STATUS,
    description: string,
    parentId: string,
    parentName: string,
    createdById: string,
    createdByName: string,
    assignedTo: string | null,
    assignToMailId: string,
    assignedName: string | null,
    businessId: string,
    pipeline: {
        id: "",
        name: ""
    },
    pipelineStage: {
        id: "",
        name: ""
    },
    leadNumber: string,
    labelIds: any[],
    labels: CrmLabel[]
}

export interface TaskRepeat {
    startRemainder: string,
    endRemainder: string,
    taskRepeat: TASK_REPEAT,
    taskEndOn: TASK_END_ON,
    repeatCount: number,
    endsOn: string,
    taskStatus: TASK_STATUS | null
}

export enum PRIORITY {
    "HIGH" = "HIGH",
    "MEDIUM" = "MEDIUM",
    "LOW" = "LOW"
};

export enum TASK_REPEAT {
    "DAILY" = "DAILY",
    "WEEKLY" = "WEEKLY",
    "MONTHLY" = "MONTHLY",
    "YEARLY" = "YEARLY"
}

export enum TASK_END_ON {
    "NEVER" = "NEVER",
    "AFTER_N_TIME" = "AFTER_N_TIME",
    "ON_DATE" = "ON_DATE"
}

export enum TASK_STATUS {
    "NEW" = "NEW",
    "IN_PROGRESS" = "IN_PROGRESS",
    "COMPLETED" = "COMPLETED",
    "CANCELLED" = "CANCELLED",
    "FOLLOW_UP" = "FOLLOW_UP"
}

export enum NOTIFY {
    "EMAIL" = "EMAIL",
    "POPUP" = "POPUP",
    "BOTH" = "BOTH"
}

export type CrmLabelTargetType = 'LEAD' | 'TASK' | 'CALL' | 'MEETING';

export interface CrmLabel {
    id: string;
    name: string;
    color: string;
    active: boolean;
    businessId?: string;
    createdTimeStamp?: string;
    updatedTimeStamp?: string;
}

export interface CrmLabelAssignmentRequest {
    businessId: string;
    targetType: CrmLabelTargetType;
    targetId: string;
    labelIds: string[];
}

export const CRM_LABEL_MAX_SELECTION = 20;